import { CopyIcon, Grid2x2Icon, ListIcon, PlusIcon } from 'lucide-react'
import React, { useContext, useEffect, useState } from 'react'
import { FaFilter, FaSortAlphaDown } from 'react-icons/fa'
import { MdDeleteForever } from 'react-icons/md'
import { toast } from 'react-toastify'
import { humanReadableTimePassed } from '../../../Helper/calculations'
import { BASE_URL_API } from '../../../References/URLs'
import ActiveStoreContext from '../../../store/ActiveStoreContext'
import AuthContext from '../../../store/auth-context'
import styles from './ContentSelector.module.css'
import MultiUpload from './MultiUpload'

const ContentSelector = (props) => {
    const { isOpen, onClose, onSelect } = props
    const [addingMode, setAddingMode] = useState(false)
    const [clientContent, setClientContent] = useState([1, 2, 3])
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier


    const handleOutsideClick = (e) => {
        if (e.target.id === 'contentSelectorWrapperId') {
            onClose()
        }
    }

    const getClientContent = async () => {
        const response = await fetch(BASE_URL_API + "getClientContent",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setClientContent(respo?.response)
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }

            console.log(respo)
        }
    }

    const deleteClientContentImg = async (k) => {
        if(window.confirm("Do you really want to delete?")) {
            const response = await fetch(BASE_URL_API + "deleteClientContentImg",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        vendorIdentifier: vendorIdentifier,
                        storeIdentifier: activeStore?.storeIdentifier,
                        ID : k 
                    })
                })
    
            if (!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo.status === "success") {
                    toast(`Successfully deleted the content!`)
                    getClientContent()
                } else {
                    if (respo.message === "tokenExpired") {
                        authCtx.logout()
                    }
                }
    
                console.log(respo)
            }
        }
    }

    useEffect(() => {
        if (addingMode === false) {
            getClientContent()
        }
    }, [addingMode])



    return (
        <div className={styles.mainWrapper}  >
            <div className={styles.mainContainer} id="contentSelectorWrapperId" onClick={(e) => handleOutsideClick(e)} >
                <div className={styles.mainContent}>
                    <div className={styles.mainHeader} >
                        <div>
                            <div className={styles.pageTitle}>
                                Campaign Media Manager
                            </div>
                            <div className={styles.pageSubtitle} >
                                Upload, organize, and select media for your campaigns
                            </div>
                        </div>
                        <div>
                            <button onClick={() => onClose()} >Close</button>
                        </div>
                    </div>
                    <div className={styles.mainBody}>
                        {addingMode === false ?
                            <div className={styles.actionWrapper}>
                                <div className={styles.searchWrapper} >
                                    <input placeholder="Search media..." />
                                </div>
                                <div className={styles.actionRightWrapper} >
                                    <div className={styles.actionRightContainer} >
                                        <div>
                                            <FaSortAlphaDown />
                                        </div>
                                        <div>
                                            <FaFilter />
                                        </div>

                                        <div className={styles.iconsWrapper} >
                                            <div>
                                                <Grid2x2Icon />
                                            </div>
                                            <div>
                                                <ListIcon />
                                            </div>
                                        </div>

                                        <div onClick={() => setAddingMode(true)} className={styles.addingActionBtn} >
                                            <PlusIcon />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            :
                            <div className={styles.actionWrapper}>
                                <div className={styles.searchWrapper} >
                                    Bulk upload images to your campaign
                                </div>
                                <div className={styles.actionRightWrapper} >
                                    <div onClick={() => setAddingMode(false)} className={styles.addingActionBtn} >
                                        <ListIcon />
                                    </div>
                                </div>
                            </div>
                        }

                        {addingMode === false ?
                            <div className={styles.gallaryWrapper}>
                                <div className={styles.gallaryContainer}>
                                    {clientContent?.map((item, index) => (
                                        <div key={index} className={styles.eachImgWrapper}>
                                            <div className={styles.eachImgContainer} >
                                                <img src={item?.url} />
                                            </div>
                                            <div className={styles.timeTxt}>
                                                Uploaded {humanReadableTimePassed(item?.createdOn)}
                                            </div>
                                            <div className={styles.eachActionWrapper}>
                                                <div className={styles.deleteImg} onClick={() => deleteClientContentImg(item?.ID)} >
                                                    <MdDeleteForever size={20} />
                                                </div>
                                                <div className={styles.selectImg} onClick={() => onSelect(item?.url) }>
                                                    <CopyIcon size={20} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            :
                            <div className={styles.gallaryWrapper}>
                                <MultiUpload />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContentSelector